export default __webpack_public_path__ + "static/media/phone-verification-background-logged-out-desktop.002caec8.png";